import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { InsuranceFlowService } from 'src/app/_services/insurance-flow.service';
import { InsuranceFlowStatus } from 'src/app/enums/insurance-flow/insurance-flow-status.enum';
import { ActionModalComponent } from 'src/app/shared/components/action-modal/action-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { TaskDetailsService } from '../../../../task-details.service';
import { BaseStepperAction } from '../../../task-history/stepper-actions/base-action';

@Component({
  selector: 'app-cancel-centralisation-action',
  standalone: true,
  imports: [CommonModule, NgbTooltipModule, IconsModule, ActionModalComponent],
  templateUrl: './cancel-centralisation.component.html',
})
export class CancelCentralisationComponent extends BaseStepperAction {
  @ViewChild('cancelModal') cancelModal: ActionModalComponent;

  submitted = false;

  get enabled(): boolean {
    const status = this.state?.insuranceFlowData?.status;
    return (
      status === InsuranceFlowStatus.PENDING_CENTRALISATION ||
      status === InsuranceFlowStatus.ONGOING_CENTRALISATION
    );
  }

  constructor(
    taskDetailsService: TaskDetailsService,
    private readonly insuranceFlowService: InsuranceFlowService,
    private readonly toastrService: ToastrService
  ) {
    super(taskDetailsService);
  }

  cancelCentralisation() {
    const flowId = this.state?.insuranceFlowData?.id;
    if (this.submitted || !flowId) return;
    this.submitted = true;
    this.insuranceFlowService.cancelCentralisationFlow({ flowId }).subscribe({
      next: (res) => {
        if (res.error) {
          this.toastrService.error(
            $localize`Une erreur est survenue. Veuillez réessayer ultérieurement`
          );
        } else {
          this.toastrService.success(
            $localize`Centralisation annulée avec succès`
          );
          this.cancelModal?.closeModal();
          this.refreshTaskDetails();
        }
        this.submitted = false;
      },
      error: () => {
        this.toastrService.error(
          $localize`Une erreur est survenue. Veuillez réessayer ultérieurement`
        );
        this.submitted = false;
      },
    });
  }
}
